import { generatePath } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { TopUpStepUI } from "@src/widgets/onboarding/ui/tours/AccountTopUp/TopUpStepUI"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class TopUpStep extends TourStepBase {
  component = TopUpStepUI
  name = `${ONBOARDING_TOURS.ACCOUNT_TOP_UP}_BalancesTopUp`

  constructor() {
    super({
      highlightElements: ["#GENERATED_ID_BALANCEPAGE_LINK_VOID_1"],
      placement: TOUR_MODAL_PLACEMENTS.BOTTOM_RIGHT,
    })
  }

  action() {
    return router.navigate({
      pathname: paths.balances,
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "Make sure your balances is alright",
      title: "Top up",
    }
  }
}
